import { Box } from "@mantine/core";
import classes from "./index.module.css";

/**
 * Marca da integração no catálogo e no detalhe.
 *
 * Provider com logo conhecida rende a logo de verdade; o resto continua na
 * caixa colorida com as iniciais que vêm do catálogo (`logo_text`/`logo_color`).
 * Ficou como componente porque o mesmo bloco aparece em cinco telas: card do
 * catálogo, detalhe instalado, detalhe não instalado, conexão e aba do agente.
 *
 * Arquivo estático em `public/` em vez do campo `logo` (mídia) do content-type:
 * assim a logo existe em todo ambiente sem upload manual em cada um.
 */
const BRAND_LOGOS: Record<
  string,
  { src: string; alt: string; background?: string }
> = {
  googlecalendar: {
    src: "/images/integrations/googlecalendar.png",
    alt: "Google Agenda",
  },
  // Logo branca da OralSin: precisa do verde da marca (#106834) atrás, senão
  // sumiria na superfície neutra clara que as logos coloridas usam.
  oralsin: {
    src: "/images/integrations/oralsin.svg",
    alt: "OralSin",
    background: "#106834",
  },
  // Sem `background`: logo colorida sobre a superfície neutra do tema, o mesmo
  // tratamento do Google Agenda.
  powercrm: {
    src: "/images/integrations/powercrm.png",
    alt: "Power CRM",
  },
  easydental: {
    src: "/images/integrations/easydental.svg",
    alt: "EasyDental",
  },
};

export function IntegrationLogo({
  slug,
  logoText,
  logoColor,
  size = "md",
}: {
  slug: string;
  logoText: string;
  logoColor: string;
  size?: "sm" | "md" | "lg";
}) {
  const brand = BRAND_LOGOS[slug];
  return (
    <Box
      className={classes.logo}
      data-size={size}
      data-brand={Boolean(brand)}
      data-brand-colored={Boolean(brand?.background)}
      // Logo branca (OralSin) fica sobre a cor da marca; logo colorida (Google
      // Agenda, Power CRM, EasyDental) sobre superfície neutra; sem marca, a
      // caixa de iniciais usa a cor do catálogo.
      style={
        brand?.background
          ? { background: brand.background }
          : brand
            ? undefined
            : { background: logoColor }
      }>
      {brand ? (
        <img
          src={brand.src}
          alt={brand.alt}
          className={classes.brandImage}
          loading="lazy"
          decoding="async"
        />
      ) : (
        logoText
      )}
    </Box>
  );
}
